import { HttpRequest, HttpMethod } from "./http";

class AppCatalogCampaignProvider extends HttpRequest {
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/catalog/campaigns", params);
    }

    get(id) {
        return this.request(HttpMethod.Get, `/api/v1/bo/catalog/campaigns/${id}`);
    }

    create(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/catalog/campaigns", payload);
    }

    update(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/catalog/campaigns/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/catalog/campaigns/${id}`);
    }

    // ---- แฟลชเซล page (spec 2026-10-05-flash-sale-campaign-page §5 / §6.2) ----
    //
    // The page never calls update() above: PUT /campaigns/:id REPLACES every
    // target with what it is sent, and a paged table only ever holds one page.
    // The header goes through PATCH (BE-2) and products are added / removed one
    // endpoint at a time (BE-6 / BE-7).

    // BE-2 PATCH {name, kind, value, starts_at, ends_at, status} — header only.
    patch(id, payload) {
        return this.request(HttpMethod.Patch, `/api/v1/bo/catalog/campaigns/${id}`, payload);
    }

    // BE-3 GET ?page=&page_size=&keyword=
    products(id, params) {
        return this.request(HttpMethod.Get, `/api/v1/bo/catalog/campaigns/${id}/products`, params);
    }

    // BE-4 GET — the SKU sub-table of one product row.
    productSkus(id, productId) {
        return this.request(HttpMethod.Get, `/api/v1/bo/catalog/campaigns/${id}/products/${productId}/skus`);
    }

    // BE-6 POST {product_ids} → {added, skipped, invalid, total}
    addProducts(id, productIds) {
        return this.request(HttpMethod.Post, `/api/v1/bo/catalog/campaigns/${id}/products`, {
            product_ids: productIds
        });
    }

    // BE-7 DELETE → {removed, total}
    removeProduct(id, productId) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/catalog/campaigns/${id}/products/${productId}`);
    }
}

export default AppCatalogCampaignProvider;
